export default __webpack_public_path__ + "static/media/rewfa_logo.18e4a788.svg";